module.exports = __webpack_public_path__ + "img/customer-deposit-standard.b1878c36.png";